import DynamicFieldsElementOptions from "~/models/dynamicFields/options/dynamicFieldsElementOptions";
import {IDynamicFieldsElementOptions} from "~/interfaces/dynamicFieldsElementOptionsInterfaces";
import { ObjectModelBuiltinPropertyType } from "~/enums/objectModelBuiltinPropertyType";
import ObjectModelPropertyDefinition from "~/models/objectModelProperties/objectModelPropertyDefinition";

export interface ObjectModelRecordMetadataOption {
  name: string;
  type: ObjectModelBuiltinPropertyType;
}

export class ObjectModelRecordMetadataOptions extends DynamicFieldsElementOptions<ObjectModelRecordMetadataOption, void> {
  static ALL_ELEMENTS: ObjectModelRecordMetadataOption[] = ObjectModelPropertyDefinition.builtInTypesSet(3).map(detail => {
    return {type: detail.type, name: detail.displayName};
  });

  getElements: (elementContainer: void) => ObjectModelRecordMetadataOption[];
  matcher: (element: ObjectModelRecordMetadataOption) => boolean;

  constructor(config: IDynamicFieldsElementOptions<ObjectModelRecordMetadataOption, void> = {getElements: null, matcher: null}) {
    super(config);
  }

  getElementsDefault(container: void): ObjectModelRecordMetadataOption[] {
    return ObjectModelRecordMetadataOptions.ALL_ELEMENTS;
  }
  matcherDefault(element: ObjectModelRecordMetadataOption): boolean {
    return true;
  }

  matchElements(container: void, q: string): ObjectModelRecordMetadataOption[] {
    return this.getElements(container).filter(el => el.name.toLowerCase().match(q) !== null);
  }

}
